import { Group, Pill } from "@mantine/core";
import type { JSX } from "react";
import classes from "./WhisperPill.module.css";

interface WhisperPillProps {
    whisper: string;
}

export function WhisperPill({ whisper }: WhisperPillProps): JSX.Element {
    return (
        <Group pos="relative" left={15} classNames={{ root: classes.whisperContainer }}>
            <Pill
                bg="linear-gradient(90deg, var(--mantine-color-success-4) 0.3%, #60FFFF 105.93%)"
                c="var(--mantine-color-black)"
                fw={700}
                fz="xs"
                radius={2}
                size="xs"
                w="fit-content"
            >
                {whisper}
            </Pill>
        </Group>
    );
}
